import { sbaAxios } from "../utils/sbaAxios";
import {
  FETCH_CONTACTLISTS_BEGIN,
  FETCH_CONTACTLISTS_SUCCESS,
  FETCH_CONTACTDETAILS_BEGIN,
  FETCH_CONTACTDETAILS_SUCCESS,
  FETCH_CONTACTINFO_BEGIN,
  FETCH_CONTACTINFO_SUCCESS,
  FETCH_CONTACTHEADER_SUCCESS,
  FETCH_CONTACTLISTS_FAILURE,     
  FETCH_WEBCATEGORIES_BEGIN,
  FETCH_WEBCATEGORIES_SUCCESS,
  FETCH_WEBCATEGORIES_FAILURE,
  FETCH_WEBSTATUS_BEGIN,
  FETCH_WEBSTATUS_SUCCESS,
  FETCH_WEBSTATUS_FAILURE,   
  FETCH_PARENTCOMPANIES_BEGIN,   
  FETCH_PARENTCOMPANIES_SUCCESS,
    FETCH_PARENTCOMPANIES_FAILURE,

    FETCH_ACCOUNTS_BEGIN,
    FETCH_ACCOUNTS_SUCCESS,
    FETCH_ACCOUNTS_FAILURE,
    } from '../constants/contactLists'
import { getContacts, getContactHeader, getContactInfo, getContactDetails, getContactWebCategories, getContactWebStatusTypes, getParentCompanies, getTaxEntitiesByContact} from '../../config/apiConfig';
import { updateEntity } from "../CommonAPI";

export const getContactsDataAction=(type)=>{ 
  return async (dispatch) => {
    dispatch(getContactsDataActionBegin());
      try {
          const response = await sbaAxios({
              url: `${getContacts}?&type=${type}`,
              method: 'get',
          })
        const ContactData = response;
        dispatch(getContactsDataActionSuccess(ContactData));
      } catch (error) {
        if (error.message === 'Network Error') {
          dispatch(getContactsDataActionSuccess({}));
        } else {
          dispatch(getContactsDataActionFailure(error));
        }
      }
  };
}

export const getContactsDataActionBegin = () => ({
    type: FETCH_CONTACTLISTS_BEGIN,
  });
  
  export const getContactsDataActionSuccess = (ContactData) => ({
    type: FETCH_CONTACTLISTS_SUCCESS,
    payload: {ContactData},
  });

  export const getContactsDetailsAction=(contactId)=>{ 
    return async (dispatch) => {
      dispatch(getContactsDetailsActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getContactInfo}${contactId}`,
                method: 'get',
            })
          const ContactDetails = response;
          dispatch(getContactsDetailsActionSuccess(ContactDetails));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getContactsDetailsActionSuccess({}));
          } else {
            dispatch(getContactsDataActionFailure(error));
          }
        }
    };
  }

export const getContactsInfoAction = (contactId) => {
    return async (dispatch) => {
      dispatch(getContactsInfoActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getContactInfo}${contactId}`,
                method: 'get',
            })
          const ContactInfo = response;
          dispatch(getContactsInfoActionSuccess(ContactInfo));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getContactsInfoActionSuccess({}));
          } else {
            dispatch(getContactsDataActionFailure(error));
          }
        }
    };
  }

  export const getContactsHeaderAction=(contactId)=>{ 
    return async (dispatch) => {
      dispatch(getContactsDetailsActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getContactHeader}${contactId}`,
                method: 'get',
            })
          const ContactsHeader = response;
          updateEntity("InvestorId",contactId);
          dispatch(getContactsHeaderActionSuccess(ContactsHeader));
        } catch (error) {
          if (error.message === 'Network Error') {
            dispatch(getContactsHeaderActionSuccess({}));
          } else {
            dispatch(getContactsDataActionFailure(error));
          }
        }
    };
  }
  
  export const getContactsDetailsActionBegin = () => ({
      type: FETCH_CONTACTDETAILS_BEGIN,
    });
    
    export const getContactsHeaderActionSuccess = (ContactsHeader) => ({
      type: FETCH_CONTACTHEADER_SUCCESS,
      payload: {ContactsHeader},
    });

    export const getContactsInfoActionBegin = () => ({
      type: FETCH_CONTACTINFO_BEGIN,
    });
    
    export const getContactsDetailsActionSuccess = (ContactDetails) => ({
      type: FETCH_CONTACTDETAILS_SUCCESS,
      payload: {ContactDetails},
    });

    export const getContactsInfoActionSuccess = (ContactInfo) => ({
      type: FETCH_CONTACTINFO_SUCCESS,
      payload: {ContactInfo},
    });

  export const getContactsDataActionFailure = (errorMessage) => ({
    type: FETCH_CONTACTLISTS_FAILURE,
    payload: {errorMessage}
  });

  // Web Categories
export const getWebCategoriesAction = () => {
  return (dispatch) => {
      dispatch(fetchWebCategoryBegin());
      sbaAxios({
          url: `${getContactWebCategories}`,
          method: 'get',
      })
          .then((repos) => {
              const webCategories = repos;
              dispatch(fetchWebCategorySuccess(webCategories));
              return webCategories;
          })
          .catch((error) => { return dispatch(fetchWebCategoryFailure(error)) });
  };
}

export const fetchWebCategoryBegin = () => ({
  type: FETCH_WEBCATEGORIES_BEGIN,
});

export const fetchWebCategorySuccess = (webCategories) => ({
  type: FETCH_WEBCATEGORIES_SUCCESS,
  payload: { webCategories },
});

export const fetchWebCategoryFailure = (errorMessage) => ({
  type: FETCH_WEBCATEGORIES_FAILURE,
  payload: { errorMessage }
});

// Web Status
export const getWebStatusTypesAction = () => {
  return (dispatch) => {
      dispatch(fetchWebStatusTypesBegin());
      sbaAxios({
          url: `${getContactWebStatusTypes}`,
          method: 'get',
      })
          .then((repos) => {
              const webStatusTypes = repos;
              dispatch(fetchWebStatusTypesSuccess(webStatusTypes));
              return webStatusTypes;
          })
          .catch((error) => { return dispatch(fetchWebStatusTypesFailure(error)) });
  };
}

export const fetchWebStatusTypesBegin = () => ({
  type: FETCH_WEBSTATUS_BEGIN,
});

export const fetchWebStatusTypesSuccess = (webStatusTypes) => ({
  type: FETCH_WEBSTATUS_SUCCESS,
  payload: { webStatusTypes },
});

export const fetchWebStatusTypesFailure = (errorMessage) => ({
  type: FETCH_WEBSTATUS_FAILURE,
  payload: { errorMessage }
});

// Parent Companies
export const getParentCompaniesAction = (contactTypeId) => {
  return (dispatch) => {
      dispatch(fetchParentCompaniesBegin());
      sbaAxios({
          url: `${getParentCompanies}${contactTypeId}`,
          method: 'get',
      })
          .then((repos) => {
              const parentCompanies = repos;
              dispatch(fetchParentCompaniesSuccess(parentCompanies));
              return parentCompanies;
          })
          .catch((error) => { return dispatch(fetchParentCompaniesFailure(error)) });
  };
}

export const fetchParentCompaniesBegin = () => ({
  type: FETCH_PARENTCOMPANIES_BEGIN,
});

export const fetchParentCompaniesSuccess = (parentCompanies) => ({
  type: FETCH_PARENTCOMPANIES_SUCCESS,
  payload: { parentCompanies },
});

export const fetchParentCompaniesFailure = (errorMessage) => ({
  type: FETCH_PARENTCOMPANIES_FAILURE,
  payload: { errorMessage }
});

export const getTaxEntitiesByContactAction = (contactId) => {
    return async (dispatch) => {
        dispatch(getTaxEntitiesByContactActionBegin());
        try {
            const response = await sbaAxios({
                url: `${getTaxEntitiesByContact}${contactId}`,
                method: 'get',
            })
            const TaxEntities = response;
          
            dispatch(getTaxEntitiesByContactActionSuccess(TaxEntities));
        } catch (error) {
            if (error.message === 'Network Error') {
                dispatch(getTaxEntitiesByContactActionSuccess({}));
            } else {
                dispatch(getTaxEntitiesByContactActionFailure(error));
            }
        }
    };
}

export const getTaxEntitiesByContactActionBegin = () => ({
    type: FETCH_ACCOUNTS_BEGIN,
});

export const getTaxEntitiesByContactActionSuccess = (TaxEntities) => ({
    type: FETCH_ACCOUNTS_SUCCESS,
    payload: { TaxEntities },
});

export const getTaxEntitiesByContactActionFailure = (errorMessage) => ({
    type: FETCH_ACCOUNTS_FAILURE,
    payload: { errorMessage }
});